import filter from "lodash/filter";
import map from "lodash/map";

export function GetDefaultCheckedLanguages(languages) {
    return filter(languages, o => o.checkedByDefault === true);
}

export function GetDefaultCheckedLanguagesCodes(languages) {
    const defaultsLangs = GetDefaultCheckedLanguages(languages);
    return map(defaultsLangs, "code");
}

export function GetContentTranslations(translations) {

    const enabledLangs = [];
    const langsValues = {};
    const taglineTwitter = {};
    const headlineTwitter = {};

    let langData = null;
    if (translations) {
        langData = JSON.parse(translations);
    }

    if (langData) {
        Object.keys(langData).forEach(function(key) {
            if (langData[key].isEnabled) {
                enabledLangs.push(key);
            }
            if (langData[key].value) {
                langsValues[key] = langData[key].value;
                taglineTwitter[key] = langData[key].taglineTwitter;
                headlineTwitter[key] = langData[key].headlineTwitter;
            }
        });
    }

    const obj = {
        enabledLangs: enabledLangs,
        langsValues: langsValues,
        taglineTwitter: taglineTwitter,
        headlineTwitter: headlineTwitter
    };

    return obj;
}

export function GetDefaultContentLangs(langs) {
    const langCodes = [];
    langs.forEach(lang => {
        langCodes.push(lang.code);
    });
    return langCodes.join(";");
}

export function GetDefaultTranslations(langs) {
    // {\"FR\":{\"isEnabled\":true,\"value\":\"testfr\"},\"EN\":{\"isEnabled\":true,\"value\":\"testen\"}}
    const data = {};
    langs.forEach(lang => {
        data[lang.code] = {};
        data[lang.code].isEnabled = lang.checkedByDefault;
        data[lang.code].value = "";
    });
    return data;
}
